import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { SkinInterface, setEditId, setEditError, selectSkinById } from "../../../store/mine_craft/skinsSlice";
import { updateSkin, fetchSkin } from "../../../actions/mine_craft/skinsActions";
import { objToFormData } from "../../../helpers/FormHelper";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const TARGET_ID = 1;

const Edit = () => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.mineCraft.skins.editId);
  const error     = useAppSelector(state => state.mineCraft.skins.editError);
  const skin      = useAppSelector(state => id ? selectSkinById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchSkin(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: SkinInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: SkinInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateSkin({ id, data: formData }));

    if (updateSkin.fulfilled.match(resultAction)) {
      onClose();

      if (skin?.category_id !== data.category_id || skin?.subcategory_id !== data.subcategory_id) {
        navigate(0);
      }
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-skin'>
        <h6 className="v-content-label">Edit Skin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={skin} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
